import React from 'react';

export interface SignalCancelProps {
  size?: number;
}

export const SignalCancel: React.FC<SignalCancelProps> = ({ size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 12 12" fill="none" aria-hidden>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.3327 5.99984C11.3327 8.94536 8.94487 11.3332 5.99935 11.3332C3.05383 11.3332 0.666016 8.94536 0.666016 5.99984C0.666016 3.05432 3.05383 0.666504 5.99935 0.666504C8.94487 0.666504 11.3327 3.05432 11.3327 5.99984ZM3.68166 9.26033L9.25985 3.68215C9.00039 3.3178 8.68139 2.9988 8.31704 2.73934L2.73885 8.31753C2.99831 8.68187 3.31731 9.00088 3.68166 9.26033Z"
      fill="#261B36"
    />
  </svg>
);
